/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default [ [ "buď, buď" ], [ "buď, alebo" ], [ "ani, ani" ], [ "aj, aj" ], [ "tak, ako" ], [ "nielenže, lež aj" ],
	[ "nielen, lež aj" ], [ "nielen, lež i" ], [ "nielenže, lež ai" ], [ "či, alebo" ], [ "i, i" ], [ "nielen, ale i" ],
	[ "síce, ale" ] ];

